const COUNTRY_NAME_TO_ISO: { [name: string]: string } = {
  "antigua and barbuda": "AG",
  argentina: "AR",
  australia: "AU",
  bahamas: "BS",
  bahrain: "BH",
  bangladesh: "BD",
  barbados: "BB",
  belgium: "BE",
  belize: "BZ",
  bermuda: "BM",
  brazil: "BR",
  "british virgin islands": "VG",
  canada: "CA",
  "cayman islands": "KY",
  chile: "CL",
  china: "CN",
  colombia: "CO",
  "costa rica": "CR",
  croatia: "HR",
  cuba: "CU",
  cyprus: "CY",
  denmark: "DK",
  ecuador: "EC",
  egypt: "EG",
  england: "GB",
  finland: "FI",
  france: "FR",
  germany: "DE",
  ghana: "GH",
  gibraltar: "GI",
  "great britain": "GB",
  greece: "GR",
  "hong kong": "HK",
  india: "IN",
  indonesia: "ID",
  ireland: "IE",
  israel: "IL",
  italy: "IT",
  jamaica: "JM",
  japan: "JP",
  kenya: "KE",
  "korea, republic of": "KR",
  kuwait: "KW",
  liberia: "LR",
  malaysia: "MY",
  malta: "MT",
  "marshall islands": "MH",
  mexico: "MX",
  morocco: "MA",
  netherlands: "NL",
  "new zealand": "NZ",
  nigeria: "NG",
  norway: "NO",
  oman: "OM",
  pakistan: "PK",
  panama: "PA",
  peru: "PE",
  philippines: "PH",
  poland: "PL",
  portugal: "PT",
  qatar: "QA",
  romania: "RO",
  russia: "RU",
  "russian federation": "RU",
  "saudi arabia": "SA",
  singapore: "SG",
  "south africa": "ZA",
  "south korea": "KR",
  spain: "ES",
  sweden: "SE",
  taiwan: "TW",
  thailand: "TH",
  "trinidad and tobago": "TT",
  turkey: "TR",
  "u.k.": "GB",
  "u.s.": "US",
  "u.s.a.": "US",
  uae: "AE",
  uk: "GB",
  ukraine: "UA",
  "united arab emirates": "AE",
  "united kingdom": "GB",
  "united states": "US",
  "united states of america": "US",
  usa: "US",
  vietnam: "VN",
  "virgin islands": "VI",
};

export function toIsoCountry(value?: string | null): string | undefined {
  if (!value) {
    return undefined;
  }
  const trimmed = value.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }
  return COUNTRY_NAME_TO_ISO[trimmed.toLowerCase()];
}
